export default {
  meta: {
    title: '实验报告与归因',
    parentPath: ['/decision/experiment'],
    breadcrumbs: [
      { path: '/decision/workbench', title: '实验工作台' },
      { path: '/decision/experiment', title: '实验管理' },
      { title: '实验报告与归因' },
    ],
  },
};
